export default "__VITE_ASSET__1e950041__"